export const formatarMoeda = (valor) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);

export const formatarCompacto = (valor) => {
  if (valor >= 1e6) return `R$ ${(valor / 1e6).toFixed(2)}M`;
  if (valor >= 1e3) return `R$ ${(valor / 1e3).toFixed(0)}K`;
  return formatarMoeda(valor);
};

export const formatarPercentual = (valor) => `${valor.toFixed(2)}%`;